export default __webpack_public_path__ + "static/keepass-139bee27bf7cb604bc2a1d64b8776f20.png";